module.exports = __webpack_public_path__ + "img/Book.155e034f.webp";